import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import PostcodeChecker from "@/components/PostcodeChecker";
import { MapPin } from "lucide-react";

export default function ServiceAreaPage() {
  const { t, lang } = useLang();
  const sa = t.seo.area;
  useEffect(() => {
    document.title = lang === "da" ? "Serviceområde | Belov Multiservice" : "Service area | Belov Multiservice";
  }, [lang]);

  return (
    <div data-testid="service-area-page">
      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
        <h1 className="text-3xl sm:text-5xl font-display font-extrabold tracking-tight text-stone-900">{t.area.title}</h1>
        <p className="mt-4 text-lg text-stone-600">{t.area.subtitle}</p>
        <div className="mt-8"><PostcodeChecker /></div>

        <div className="mt-14 space-y-8" data-testid="area-seo">
          <p className="text-stone-600 leading-relaxed">{sa.introText}</p>
          <div>
            <h2 className="text-xl sm:text-2xl font-display font-bold tracking-tight text-stone-900">{sa.citiesTitle}</h2>
            <ul className="mt-4 flex flex-wrap gap-2.5">
              {sa.cities.map((c, i) => (
                <li key={i} className="inline-flex items-center gap-2 rounded-full bg-[#F4F1EA] px-4 py-2 text-sm font-medium text-stone-700">
                  <MapPin className="w-4 h-4 text-emerald-600" /> {c}
                </li>
              ))}
            </ul>
          </div>
          <p className="text-stone-600 leading-relaxed">{sa.outsideText}</p>
          <div>
            <h2 className="text-lg font-display font-bold text-stone-900">{sa.linksTitle}</h2>
            <div className="mt-3 flex flex-wrap gap-3" data-testid="area-seo-links">
              <Link to="/moebelmontering-koebenhavn" className="inline-flex items-center gap-2 rounded-full border border-stone-300 bg-white px-5 py-2.5 text-sm font-semibold text-stone-800 hover:bg-stone-50" data-testid="area-link-koebenhavn">Møbelmontering i København</Link>
              <Link to="/moebelmontering-nordsjaelland" className="inline-flex items-center gap-2 rounded-full border border-stone-300 bg-white px-5 py-2.5 text-sm font-semibold text-stone-800 hover:bg-stone-50" data-testid="area-link-nordsjaelland">Møbelmontering i Nordsjælland</Link>
              <Link to="/pax-montering" className="inline-flex items-center gap-2 rounded-full border border-stone-300 bg-white px-5 py-2.5 text-sm font-semibold text-stone-800 hover:bg-stone-50">{t.nav.pax}</Link>
              <Link to="/ikea-koekken" className="inline-flex items-center gap-2 rounded-full border border-stone-300 bg-white px-5 py-2.5 text-sm font-semibold text-stone-800 hover:bg-stone-50">{t.nav.kitchen}</Link>
              <Link to="/oevrige-moebler" className="inline-flex items-center gap-2 rounded-full border border-stone-300 bg-white px-5 py-2.5 text-sm font-semibold text-stone-800 hover:bg-stone-50">{t.nav.other}</Link>
              <Link to="/kontakt" className="inline-flex items-center gap-2 rounded-full border border-stone-300 bg-white px-5 py-2.5 text-sm font-semibold text-stone-800 hover:bg-stone-50">{t.footer.contactPage}</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
